/* assets/collections-index.js
   Powers the /collections landing page: while hovering a collection's
   image, its name (a <span> already in the markup, see
   snippets/collections-index-item.liquid) follows the cursor. The
   light/dark color-invert look comes from CSS (mix-blend-mode:difference
   in theme-minimal.css) — this script only has to keep the label
   positioned under the pointer.

   Skipped entirely on touch/coarse-pointer devices, since there's no
   cursor to follow there; theme-minimal.css shows the label centered and
   always-on for those instead. */
(function () {
  function init() {
    var root = document.querySelector('[data-collections-index]');
    if (!root || root.dataset.collectionsIndexBound) return;
    root.dataset.collectionsIndexBound = 'true';

    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

    root.querySelectorAll('[data-collections-index-item]').forEach(function (item) {
      var label = item.querySelector('[data-collections-index-label]');
      if (!label) return;

      item.addEventListener('mousemove', function (e) {
        var rect = item.getBoundingClientRect();
        var x = e.clientX - rect.left;
        var y = e.clientY - rect.top;
        label.style.transform = 'translate(' + x + 'px, ' + y + 'px) translate(-50%, -50%)';
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
